module.exports = "/_next/static/images/img_list-1-a1ca9439ce76160447256c47dba70e31.webp";